import I18n from 'I18n';
import styled from 'styled-components';
// NOTE: despite the `conversations-` prefix, this package (as of 2023-08-29) has no conversations-specific dependencies
import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Details = styled.div.withConfig({
  displayName: "ReassignmentSelectInputPlaceholder__Details",
  componentId: "sc-4yd5ra-0"
})(["display:flex;flex-direction:column;justify-content:space-around;width:100%;height:100%;"]);
const ReassignmentSelectInputPlaceholder = () => /*#__PURE__*/_jsxs(Flex, {
  alignItems: "center",
  "aria-busy": true,
  "aria-label": I18n.text('routing-ui.reassignment.dropdownPlaceholder'),
  "aria-live": "polite",
  as: "div",
  blockSize: "2em",
  "data-test-id": "reassignment-select-placeholder",
  inlineSize: "11em",
  paddingInlineEnd: "250",
  role: "progressbar",
  children: [/*#__PURE__*/_jsx(Flex, {
    marginInlineEnd: "100",
    children: /*#__PURE__*/_jsx(SkeletonCircle, {
      size: 24,
      use: "on-shade"
    })
  }), /*#__PURE__*/_jsx(Details, {
    children: /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "100%",
      blockSize: "0.75em",
      use: "on-shade"
    })
  })]
});
ReassignmentSelectInputPlaceholder.displayName = 'ReassignmentSelectInputPlaceholder';
export default ReassignmentSelectInputPlaceholder;